import React from 'react'

import './errorUI.css'
const ErrorUI = () => {
  return (
    <div className="parent404">
    <div className='middleLayer404'>
        <img src={"/assets/imgs/sad.png"} alt='notfound'/>
        
        <h3>Something Went Wrong</h3>
    </div>


</div>
  )
}

export default ErrorUI